
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const companycategories = state => state.companycategories;
const getsingle = state => param =>state.companycategories.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  companycategories,
  getsingle
};